import axios from "axios";
import { FetchConsts } from "./fetchConsts";
import createUUID from "../utils/guid";
import { toBool } from "../utils/utils";

export const registerUser = (
  email,
  password,
  retypePassword,
  firstName,
  surname,
  pathronymic,
  companyName,
  isSendLetter
) => {
  const body = {
    userName: email,
    password: password,
    retypePassword: retypePassword,
    firstName: firstName,
    surname: surname,
    pathronymic: pathronymic,
    companyName: companyName,
    isSendLetter: isSendLetter,
    email: email,
  };

  const options = {
    method: "post",
    data: body,
  };

  return axios("api/account/register", options);
};

export const forgotPassword = (email, newPassword, sendPasswordLetter) => {
  const body = {
    newPassword: newPassword,
    email: email,
    sendPasswordLetter: toBool(sendPasswordLetter),
  };

  const options = {
    method: "post",
    data: body,
  };

  return axios("api/account/ForgotPassword", options);
};

export const loginUser = (email, password, rememberMe, onGetUser, onError) => {
  const body = {
    userName: email,
    password: password,
    email: email,
    rememberMe: rememberMe,
    deviceId: getDeviceId(),
  };

  const options = {
    method: "post",
    data: body,
  };

  localStorage.setItem(FetchConsts.rememberMeName, rememberMe);

  axios("api/account/login", options)
    .then((response) => {
      const { token, refreshToken, ...rest } = response.data;
      saveJwtToken(token);
      saveRefreshToken(refreshToken);
      if (onGetUser) onGetUser(rest);
    })
    .catch((error) => {
      if (onError) onError(error);
    });
};

const getRememberMe = () => {
  return toBool(localStorage.getItem(FetchConsts.rememberMeName));
};

const receiveNewRefreshTokenFromServer = (onOk, onError) => {
  const options = {
    method: "post",
    data: {
      deviceId: getDeviceId(),
      oldRefreshToken: getRefreshToken(),
    },
  };

  fetchWithCredentials("api/token/updateRefreshToken", options, onOk, onError);
};

const deleteRefreshTokenOnServer = (oldRefreshToken, onError) => {
  const options = {
    method: "post",
    data: {
      deviceId: getDeviceId(),
      oldRefreshToken: oldRefreshToken,
    },
  };

  fetchWithCredentials(
    "api/token/deleteOldRefreshToken",
    options,
    (response) => {},
    onError
  );
};

export const updateRefreshToken = (onError) => {
  const oldRefreshToken = getRefreshToken();
  receiveNewRefreshTokenFromServer((newRefreshToken) => {
    saveRefreshToken(newRefreshToken.data);
    deleteRefreshTokenOnServer(oldRefreshToken, onError);
  }, onError);
};

const getDeviceId = () => {
  const deviceIdName = "deviceId";
  let id = localStorage.getItem(deviceIdName);
  if (!id) {
    id = createUUID();
    localStorage.setItem(deviceIdName, id);
  }
  return id;
};

export const logoutUser = (onSuccess, onError) => {
  const options = {
    method: "post",
    data: {
      refreshToken: getRefreshToken(),
      deviceId: getDeviceId(),
    },
  };

  fetchWithCredentials(
    "api/account/logout",
    options,
    (response) => {
      if (response.status === 200) {
        saveRefreshToken("");
        saveJwtToken("");
        if (onSuccess) onSuccess();
      }
    },
    onError
  );
};

export function fetchWithCredentials(url, options, onOk, onError) {
  var jwtToken = getJwtToken();
  options = options || {};
  options.headers = options.headers || {};
  options.headers["Authorization"] = "Bearer " + jwtToken;

  axios(url, options)
    .then((response) => {
      if (onOk) onOk(response);
      return;
    })
    .catch((error) => {
      if (
        error &&
        error.response &&
        error.response.status === 401 &&
        error.response.headers["token-expired"]
      ) {
        refreshToken(onError, () => {
          //repeat the original request
          fetchWithCredentials(url, options, onOk, onError);
        });
      } else {
        //status is not 401 and/or there's no Token-Expired header
        if (onError) onError(error); //return the original 401 response
        return;
      }
    });
}

export const refreshToken = (onError, onOk) => {
  var refreshTokenValue = getRefreshToken();
  var jwtToken = getJwtToken();
  refreshAccessToken(jwtToken, refreshTokenValue)
    .then((refreshResponse) => {
      const { token } = refreshResponse.data;
      saveJwtToken(token);

      if (onOk) onOk(refreshResponse);
    })
    .catch((error) => {
      //failed to refresh so return original 401 response
      if (onError) onError(error);
    });
};

function refreshAccessToken(jwtToken, refreshToken) {
  return axios("api/token/refresh", {
    method: "POST",
    data: {
      token: jwtToken,
      refreshToken: refreshToken,
      deviceId: getDeviceId(),
    },
  });
}

function getJwtToken() {
  if (getRememberMe() === true) return localStorage.getItem(FetchConsts.token);
  return sessionStorage.getItem(FetchConsts.token);
}

function getRefreshToken() {
  if (getRememberMe() === true)
    return localStorage.getItem(FetchConsts.refreshToken);
  return sessionStorage.getItem(FetchConsts.refreshToken);
}

export function saveJwtToken(token) {
  if (getRememberMe() === true) localStorage.setItem(FetchConsts.token, token);
  else sessionStorage.setItem(FetchConsts.token, token);
}

function saveRefreshToken(refreshToken) {
  if (getRememberMe() === true)
    localStorage.setItem(FetchConsts.refreshToken, refreshToken);
  else sessionStorage.setItem(FetchConsts.refreshToken, refreshToken);
}
